<template>
    <section>
        <div class="row" v-for="be in basket.basketElements">
            <div class="kedvenciam_all_area">
                <div class="col-sm-12">
                    <div class="single_kedvenciam_all">
                        <div class="row">
                            <div class="col-sm-3">
                                <div class="kedvenciam_all_small_can">
                                    <img :src="be.product.imageUrl" alt="">
                                </div>
                            </div>
                            <div class="col-sm-2">
                                <div class="kedvenciam_all_small_title">
                                    <h6>{{be.product.name}}</h6>
                                </div>
                            </div>
                            <div class="col-sm-1">
                                <div class="kedvenciam_all_quantity_small_title">
                                    <p>{{be.product.price && be.product.price.toLocaleString('hu')}} Ft</p>
                                </div>
                            </div>
                            <div class="col-sm-1">
                                <div class="kedvenciam_all_quantity_small_title">
                                    <p>{{be.quantity}} db</p>
                                </div>
                            </div>
                            <div class="col-sm-2">
                                <div class="thm_btn_boxes">
                                    <div class="ozz_btn text-center">
                                        <p>{{be.priceTotal && be.priceTotal.toLocaleString('hu')}} Ft</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-2">
                                <div class="thm_btn_boxes">
                                    <div class="kedvenciam_all_quantity_small_title">
                                        <p>Tömeg: {{be.productExtra.grossWeight / 1000}} kg</p>
                                        <p>Költség: {{(be.priceTotal + be.productExtra.additionalPrice).toLocaleString('hu')}} Ft</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="kedvenciam_all_area">
                <div class="col-sm-12">
                    <div class="single_kedvenciam_all again_bg">
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="termekek_title again">
                                    <p class="new_rester">Termékek összesen: </p>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="total_termekek_results text-right">
                                    <p class="res_ter bl_red">
                                        {{basket.priceTotal && basket.priceTotal.toLocaleString('hu')}} Ft
                                    </p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="kedvenciam_all_area">
                <div class="col-sm-12">
                    <div class="single_kedvenciam_all again_bg">
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="termekek_title again">
                                    <p class="new_rester">Csomag tömege: </p>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="total_termekek_results text-right">
                                    <!-- <p>
                                        Nettó tömeg: {{basket.productExtra.netWeight}} g
                                    </p> -->
                                    <p >
                                        Bruttó tömeg: {{basket.productExtra.grossWeight/1000}} kg
                                    </p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="kedvenciam_all_area">
                <div class="col-sm-12">
                    <div class="single_kedvenciam_all again_bg">
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="termekek_title again">
                                    <p class="new_rester">Csomag teljes ára (termék + göngyöleg): </p>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="total_termekek_results text-right">
                                    <p class="res_ter bl_red">
                                        {{basket.priceTotalWithPackage && basket.priceTotalWithPackage.toLocaleString('hu')}} (net.: {{(basket.priceTotalWithPackage / 1.27).toFixed(0).toLocaleString('hu')}}) Ft
                                    </p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="kedvenciam_all_area">
                <div class="col-sm-12">
                    <div class="single_kedvenciam_all again_bg">
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="termekek_title again">
                                    <p class="new_rester">Szállítási díj (csak kiszállításnál): </p>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="total_termekek_results text-right">
                                    <p class="res_ter bl_red">
                                        {{(basket.priceTotalWithShipping-basket.priceTotalWithPackage).toLocaleString('hu')}} Ft
                                    </p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="row">
            <div class="kedvenciam_all_area">
                <div class="col-sm-12">
                    <div class="single_kedvenciam_all again_bg_secnd">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="thm_last_btn text-right">
                                    <router-link tag="a" to="/checkout/data">TOVÁBB</router-link>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default{
    computed:{
        basket:function () {
            return this.$store.getters.getBasket;
        }
    },
}
</script>

<style>
.kedvenciam_all_small_can img{
    width: 50%;
}
</style>



// WEBPACK FOOTER //
// FlowBasket.vue?43d6a67f